module.exports = __webpack_public_path__ + "img/about1.8f32e699.jpg";